import React, { Component } from "react";
import employees from './Employees'
import EmployeesRender from './FeaturedEmployeRender'

export default class AboutUs extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const employeesRender = employees.map(item => <EmployeesRender key={item.id} item={item} />)
    return (
      <div className="">
        <div className="about-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">About us</h1>
        </div>
        <div className="container mt-4">
          <div className="card">
            <div className="card-body">
              <div className="card-title">
                <h3>About Unitravel</h3>
              </div>
              <p className="card-text">
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Vestibulum cursus dui est, ac fringilla sem laoreet nec. Sed
                feugiat vehicula lorem, et blandit lectus pharetra eu. Etiam
                condimentum sem nec lectus fringilla dictum. Donec et placerat
                mauris, ut pellentesque lorem. Proin vitae nisi ex. Duis orci
                libero, iaculis sed erat eu, cursus iaculis enim. In quam
                tortor, efficitur congue felis quis, pellentesque maximus enim.
                Nam maximus cursus mauris, sed tincidunt lacus. Integer id
                dapibus enim. Etiam vitae imperdiet dui. Fusce in convallis sem.
                Nam ullamcorper ligula sed ligula rhoncus auctor. Pellentesque
                ac ligula leo. Cras est velit, dictum quis mi at, placerat
                interdum nulla.
              </p>
              <div>
                <h5 className="card-subtitle mb-2">Our services</h5>
                <ul>
                  <li>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Donec molestie tincidunt dignissim.
                  </li>
                  <li>
                    Aenean ultricies feugiat accumsan. Cras lobortis eu nibh at
                    maximus. Fusce auctor.
                  </li>
                  <li>
                    Curabitur varius efficitur felis in facilisis. Praesent
                    rutrum dictum tortor cursus lacinia.
                  </li>
                  <li>
                    Duis blandit diam nulla, vulputate ultricies orci vehicula
                    id. Sed dapibus urna.
                  </li>
                  <li>
                    Praesent mollis ultrices purus, eget convallis massa tempus
                    et. Curabitur nibh enim.
                  </li>
                </ul>
              </div>
              <div className="card-title">
                <h3>Our employees</h3>
              </div>
              {employeesRender}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
